<template>
  <div>
    <b-form @submit.prevent="validarFormularioControles()" data-vv-scope="form_controles">
      <b-row>
        <b-col lg="4">
          <b-form-group>
            <label for="nombre">Código de control</label>
            <b-form-input
              id="codigo"
              name="codigo"
              type="text"
              maxlength="6"
              v-model="selectedControles.codigo"
              data-vv-as=" "
              v-validate="
                'required|max:6'
              "
            >
            </b-form-input>
            <span class="text-danger span-error small">{{ errors.first('form_controles.codigo') }}</span>
          </b-form-group>
        </b-col>
        <b-col lg="8"> 
          <b-form-group>
            <label for="nombre">Descripción</label>
            <b-form-input
              id="nombre"
              name="nombre"
              type="text"
              v-model="selectedControles.control"
              data-vv-as=" "
              v-validate="
                'required'
              "
            >
            </b-form-input>
            <span class="text-danger span-error small">{{ errors.first('form_controles.nombre') }}</span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="row justify-content-center">
          <b-button variant="primary" type="submit" size="sm">
            <i class="fa fa-floppy-o"></i> Guardar
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "modal-controles",
  data() {
    return {};
  },
  methods: {
    async validarFormularioControles() {
      this.$validator.validateAll("form_controles").then(async (result) => {
        if (result) {
          await this.crearActualizarControl();
        }
      });
    },
    async crearActualizarControl() {  
      console.log(this.accionControl);
      if (this.accionControl == "Crear") {
        await this.crearControl();
      } else {
        await this.actualizarControl();
      }
      await this.getControles();
      this.$emit("vModalControles", false);
      this.resetSelectedControl();
    },
    ...mapActions("administracion", [
      "getControles",
      "crearControl",
      "actualizarControl",
    ]),
    ...mapMutations("administracion", [
      "resetSelectedControl",
      "setVisualizarModalControles",
    ]),
  },
  computed: {
    ...mapState("administracion", ["selectedControles", "accionControl"]),
  },
};
</script>